import { getSportBackgroundImageUrl } from '../../../sport/sportBackgroundImage'
import type { OrgRegistration } from '../types'

/**
 * The sport artwork behind a registration card — the same art the Team Finder
 * cards and competition headers fall back to. The registration carries its
 * sport records inline, so no lookup in the sports store is needed.
 */
export const getRegistrationSportArt = (
  registration: Pick<OrgRegistration, 'sport' | 'genericSport'>
): string =>
  getSportBackgroundImageUrl({
    genericSport: registration.genericSport,
    isSoccer: registration.sport?.name === 'soccer',
    sport: registration.sport,
  })

/** The sport's display name, preferring the more specific basic-stats sport. */
export const getRegistrationSportName = (
  registration: Pick<OrgRegistration, 'sport' | 'genericSport'>
): string =>
  registration.genericSport?.name || registration.sport?.name_full || ''
